import { Get } from '../helpers';
import { GREENROOM_HOST } from '@/utils/connections/endpoints';

const GetGreenroomMeetingFeatureFlags = (meetingId: number): Promise<Record<string, boolean> | null> => {
  return Get({
    host: GREENROOM_HOST,
    url: `/v2/greenroom/feature-flag-overrides/meeting/${meetingId}`,
    headers: {
      'bl-global-resource': 'false',
    },
  });
};

export default GetGreenroomMeetingFeatureFlags;
